<template>
  <div id="popup" class="popup" @mousedown="backgroundClickedCancel">
    <div class="popup-inner">
      <div class="popup-head">
        <slot name="head">
          <span class="title">{{ title }}</span>
        </slot>
        <!-- 这里的cancelHandle需要带一个参数，用于判断 -->
        <i class="icon-close" title="关闭" @click="cancelHandle('firstOff')">
          <icon-base
            :icon-name="Icons.PopupClose.iconName"
            v-bind="Icons.PopupClose"
          >
            <icon-popup-close
              class="path-icon-close"
              :icon-name="Icons.PopupClose.iconName"
              v-bind="Icons.PopupClose"
            />
          </icon-base>
        </i>
      </div>
      <div class="popup-content" v-show="contentShow ? true : false">
        <slot name="content">
          <el-input placeholder="项目名称"></el-input>
        </slot>
      </div>
      <div class="popup-buttons">
        <slot name="buttons">
          <el-button
            class="primary"
            v-if="primaryButton !== 'false'"
            @click="confirmHandle"
            :style="{ width: primaryWidth }"
          >
            {{ primaryButton }}
          </el-button>
          <el-button
            v-if="cancelButton !== 'false'"
            class="cancel"
            @click="cancelHandle"
            :style="{ width: cancelWidth }"
          >
            {{ cancelButton }}
          </el-button>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
import IconPopupClose from "@/components/icons/typography/PopupClose";

export default {
  name: "gta-popup",
  components: { IconPopupClose },
  props: {
    // 弹窗主题
    title: {
      type: String,
      default: "新建项目"
    },
    // 主要按钮命名
    primaryButton: {
      type: String,
      default: "确定"
    },
    // 主要按钮宽度
    primaryWidth: {
      type: String,
      default: "90px"
    },
    // 取消按钮宽度
    cancelWidth: {
      type: String,
      default: "90px"
    },
    // 取消按钮命名
    cancelButton: {
      type: String,
      default: "取消"
    },
    contentShow: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      Icons: {
        PopupClose: {
          iconName: "关闭",
          viewBox: "0 0 14 14",
          width: "14",
          height: "14"
          // iconColor: "#fff"
        }
      }
    };
  },
  methods: {
    //  确定位置的按钮
    confirmHandle(evt) {
      this.$emit("confirm", evt);
    },
    // 取消位置的按钮
    cancelHandle(evt) {
      this.$emit("cancel", evt);
    },
    // TODO: 可以尝试改一改操作
    backgroundClickedCancel(evt) {
      // 点击背景关闭弹窗
      var target = evt.target;
      if (target.classList.contains("popup")) {
        this.cancelHandle();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $background_popup;
  z-index: 50;

  @-webkit-keyframes fadeinout {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes fadeinout {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }

  .popup-inner {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 480px;
    height: 230px;
    max-height: 72%;
    border-top: 3px solid #4c88ff;
    margin: auto;
    padding-bottom: 30px;
    background-color: $background_popup_inner;
    box-shadow: 0px 4px 14px 0px rgba(5, 27, 69, 0.12);
    color: #6c7682;
    font-size: $font_size_middle;
    // -webkit-animation: fadeinout 0.4s linear forwards;
    // animation: fadeinout 0.4s linear forwards;
  }

  .el-form {
    &::v-deep {
      .el-input__count {
        line-height: 1.5;
      }
      .el-input .el-input__count {
        position: absolute;
        top: 70%;
        right: 0.6em;
      }
    }
  }
  /deep/.el-input__inner,
  /deep/.el-textarea__inner {
    position: relative;
  }
  /deep/.el-textarea__inner {
    font-family: sans-serif;
    resize: none;
  }
  /deep/.el-input .el-input__count {
    position: absolute;
    top: 70%;
    right: 0.6em;
  }
  /deep/.el-input__count {
    position: absolute;
    right: 17px;
    bottom: -18px;
    padding: 0 5px;
  }
}
.popup-inner {
  .popup-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 55px;
    padding: 0 15px 0 30px;
    border-bottom: 1px solid #d8e5fd;
    line-height: 55px;
    .title {
      vertical-align: middle;
    }
    .icon-close {
      width: 30px;
      height: 30px;
      margin-left: auto;
      vertical-align: middle;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      &:hover::v-deep .path-icon-close {
        fill: #4c88ff;
      }
    }
  }
  .popup-content {
    padding: 0 30px;
    .el-input {
      height: 40px;
      margin-top: 30px;
      // &::v-deep input::placeholder {
      //   color: #8f939e;
      // }
    }
  }
  .popup-buttons {
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
    margin: auto;
    text-align: center;
    padding: 0 30px;
    .el-button {
      width: 90px;
      height: 40px;
      margin-left: 25px;
      font-size: $font_size_middle;
      &:first-child {
        margin-left: 0;
      }
      &.primary {
        background-color: $bgc_btn_primary;
        color: $font_color_1st;
      }
      &.cancel {
        background-color: $bgc_btn_cancel;
        color: $color_btn_cancel;
        &:active {
          border-color: $bgc_btn_cancel;
        }
      }
    }
  }
}
</style>
